export default "__VITE_ASSET__bglvtIWQ__"